import imageUrlBuilder from '@sanity/image-url'
// adjust this import to wherever your Sanity client lives
import { sanityClient } from './sanity'

const builder = imageUrlBuilder(sanityClient)

/** @param {Object} source – Sanity image object */
export function urlFor(source) {
  return builder.image(source)
}
